import { Program } from 'scripts/utils/program';

export class SingleEvent extends Program {
	constructor(date, action) {
		super();
		this.date = date;
		this.action = action;
	}
	
	
	/** @inheritDoc */
	nextOccurrence(now) {
		if(this.date < now) {
			return null;
		}
		return this.date;
	}

	/**
	 * Just clones this object, as the stored time is timezone aware.
	 * @return {SingleEvent}
	 */
	toOffset() {
		return new SingleEvent(new Date(this.date.getTime()), this.action);
	}
}